import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { useContext } from "react";
import AppContext from "../context/AppProvider";

export function BarChart({ habit }) {
  const { settings } = useContext(AppContext);

  const getData = (habit) => {
    let completed = habit.days.filter(
      (day) => day.color === settings.color
    ).length;
    let missed = habit.days.filter((day) => day.color === "black").length;
    let unmarked = habit.days.filter((day) => day.color === "white").length;
    return { completed, missed, unmarked };
  };
  getData(habit);

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
      },
    },
  };

  let percent =
    Math.round(
      (getData(habit).completed /
        (getData(habit).completed + getData(habit).missed)) *
        100
    ) + " %";
  const labels = [percent];

  const data = {
    labels,
    datasets: [
      {
        label: "Completed",
        data: [getData(habit).completed],
        backgroundColor: settings.color,
        barThickness: 50,
      },
      {
        label: "Missed",
        data: [getData(habit).missed],
        backgroundColor: "black",
        barThickness: 50,
      },
    ],
  };

  return (
    <div
      style={{
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1rem",
        width: "100%",
        height: "auto",
      }}
    >
      <Bar options={options} data={data} />
      <p>Unmarked: {getData(habit).unmarked}</p>
    </div>
  );
}
